import type { ComponentProps, CSSProperties } from 'react';
import styles from './Pressable.module.css';

export const stateLayerClass = styles.stateLayer as string;

// iOS Safari only applies :active (the press layer and press scale) once the
// page has a touch listener; a passive no-op on the document turns it on app-wide.
if (typeof document !== 'undefined') document.addEventListener('touchstart', () => undefined, { passive: true });

export interface PressableProps extends ComponentProps<'button'> {
  /** Corner radius of the ink (InkWell borderRadius). */
  radius?: number | string;
  /** Ink tint; defaults to onSurface. */
  inkColor?: string;
  /** Paint the ink above children (e.g. over images). */
  inkOnTop?: boolean;
  /** Shrink to `--press-scale` while pressed (cards, tiles). */
  pressScale?: boolean;
}

/** A `<button>` with Material ink (hover/pressed state layer), optionally scaling on press. */
export function Pressable({ radius, inkColor, inkOnTop, pressScale, className, style, type = 'button', ...rest }: PressableProps) {
  const merged: CSSProperties = { ...style };
  if (radius !== undefined) merged.borderRadius = radius;
  if (inkColor) (merged as Record<string, string>)['--ink-color'] = inkColor;
  const classes = [styles.pressable, inkOnTop ? styles.stateLayerTop : '', pressScale ? styles.pressScale : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return <button type={type} className={classes} style={merged} {...rest} />;
}
